import React from 'react';
import GhostProductListItem from '../GhostProduct';

export default function GhostGrid({ items = 12, smaller = false }) {
  return (
    <>
      {[...Array(items)].map((e, i) => <GhostProductListItem key={i} smaller={smaller} />)}
    </>
  )
}